import type { ReactNode } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IconDragHandle } from '../ui/icons';

export const SortableItem = ({
    id,
    children,
}: {
    id: string;
    children: (dragHandleProps: Record<string, any>) => ReactNode;
}) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };
    const dragHandleProps = { ...attributes, ...listeners };
    return (
        <div ref={setNodeRef} style={style} className="sortable-item">
            {children(dragHandleProps)}
        </div>
    );
};

export const DragHandleIcon = (props: Record<string, any>) => (
    <div className="drag-handle" {...props} title="Drag to reorder">
        <IconDragHandle />
    </div>
);

export const SortablePrompt = ({
    id,
    children,
}: {
    id: string;
    children: ReactNode | ((dragHandleProps: Record<string, any>) => ReactNode);
}) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };
    const dragHandleProps = { ...attributes, ...listeners };
    const isRenderProp = typeof children === 'function';

    return (
        <div ref={setNodeRef} style={style} className="sortable-prompt">
            {!isRenderProp && (
                <div className="drag-handle prompt-handle" {...dragHandleProps} title="Drag to reorder">
                    <IconDragHandle />
                </div>
            )}
            <div className="sortable-prompt-content">
                {isRenderProp ? children(dragHandleProps) : children}
            </div>
        </div>
    );
};
